(function () {
  var UNCAP_SHOP = '1d7874-4.myshopify.com';
  var UNCAP_API = 'https://partsdiagram.uncap.app/api/frontend/getCategory';
  var UNCAP_UPSELL_API = 'https://partsdiagram.uncap.app/api/frontend/upsellDesign';
  var CACHE_KEY = 'uncapCategoryCache_v2';
  var CACHE_TTL_MS = 6 * 60 * 60 * 1000;
  var PAGE_SIZE = 50;
  var MIN_QUERY_LEN = 3;
  var MAX_RESULTS = 3;
  var STYLE_ID = 'uncap-diagram-match-style';

  /* --- part-number lookup config --- */
  var PART_MIN_LEN = 6;          // min alphanumeric chars before we treat a query as a part number
  var PART_MODELS_VISIBLE = 8;   // machines shown before "Show all"
  var PART_SUGGEST_LIMIT = 10;   // candidates pulled from Shopify predictive search
  var PART_DID_YOU_MEAN = 3;     // near-miss suggestions offered on no exact match
  var PART_FUZZY_MAX = 2;        // max character difference for a "did you mean"

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = '.uncap-diagram-match{border:1px solid #f2a25c;background:#fff6ec;border-radius:6px;padding:10px 14px;margin:10px 0;font-size:14px;line-height:1.4}' +
      '.uncap-diagram-match__label{font-weight:600;display:block;margin-bottom:4px;color:#8a4a12}' +
      '.uncap-diagram-match__list{list-style:none;margin:0;padding:0}' +
      '.uncap-diagram-match__list li{margin:2px 0}' +
      '.uncap-diagram-match__list a{color:#c1560c;text-decoration:underline}' +
      '.uncap-diagram-match__list a:hover{color:#8a3d08}' +
      '.uncap-diagram-match--loading{color:#8a4a12;font-style:italic}' +
      /* part-number panel */
      '.uncap-part-match__meta{display:block;color:#8a4a12;margin-bottom:6px;font-size:13px}' +
      '.uncap-part-match__models{list-style:none;margin:0;padding:0}' +
      '.uncap-part-match__models li{margin:0 0 6px}' +
      '.uncap-part-match__model{display:block;font-weight:600;color:#5c3208}' +
      '.uncap-part-match__links a{color:#c1560c;text-decoration:underline;margin-right:2px}' +
      '.uncap-part-match__links a:hover{color:#8a3d08}' +
      '.uncap-part-match__sep{color:#c9a483;margin:0 4px}' +
      '.uncap-part-match__more{background:none;border:0;padding:0;margin-top:4px;color:#c1560c;text-decoration:underline;cursor:pointer;font:inherit}' +
      '.uncap-part-match__dym{background:none;border:0;padding:0;color:#c1560c;text-decoration:underline;cursor:pointer;font:inherit}';
    document.head.appendChild(style);
  }

  function normalize(str) {
    return (str || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function levenshtein(a, b) {
    if (a === b) return 0;
    var al = a.length, bl = b.length;
    if (al === 0) return bl;
    if (bl === 0) return al;
    var prev = new Array(bl + 1);
    for (var j = 0; j <= bl; j++) prev[j] = j;
    for (var i = 1; i <= al; i++) {
      var cur = [i];
      for (var j2 = 1; j2 <= bl; j2++) {
        var cost = a[i - 1] === b[j2 - 1] ? 0 : 1;
        cur[j2] = Math.min(prev[j2] + 1, cur[j2 - 1] + 1, prev[j2 - 1] + cost);
      }
      prev = cur;
    }
    return prev[bl];
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function getCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || (Date.now() - parsed.t) > CACHE_TTL_MS) return null;
      return parsed.data;
    } catch (e) { return null; }
  }

  function setCache(data) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), data: data }));
    } catch (e) {}
  }

  function fetchPage(page) {
    return fetch(UNCAP_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shop: UNCAP_SHOP, pageSize: PAGE_SIZE, page: page })
    }).then(function (res) {
      if (!res.ok) return null;
      return res.json();
    }).catch(function () { return null; });
  }

  var categoriesPromise = null;
  function loadCategories() {
    if (categoriesPromise) return categoriesPromise;
    var cached = getCache();
    if (cached) {
      categoriesPromise = Promise.resolve(cached);
      return categoriesPromise;
    }
    categoriesPromise = (async function () {
      var all = [];
      try {
        var first = await fetchPage(1);
        var d0 = first && first.data;
        if (!d0 || !d0.categories) return all;
        d0.categories.forEach(function (c) {
          all.push({ id: c.id, title: c.title, norm: normalize(c.title) });
        });
        var totalPages = (d0.pagination && d0.pagination.totalPages) || 1;
        if (totalPages > 1) {
          var pagePromises = [];
          for (var p = 2; p <= totalPages; p++) {
            pagePromises.push(fetchPage(p));
          }
          var results = await Promise.all(pagePromises);
          results.forEach(function (json) {
            var d = json && json.data;
            if (!d || !d.categories) return;
            d.categories.forEach(function (c) {
              all.push({ id: c.id, title: c.title, norm: normalize(c.title) });
            });
          });
        }
      } catch (e) {
        /* fail silently */
      }
      if (all.length) setCache(all);
      return all;
    })();
    return categoriesPromise;
  }

  function findMatches(query, categories) {
    var nq = normalize(query);
    if (nq.length < MIN_QUERY_LEN) return [];
    var scored = [];
    categories.forEach(function (c) {
      if (!c.norm) return;
      var score = null;
      if (c.norm.indexOf(nq) !== -1 || nq.indexOf(c.norm) !== -1) {
        score = Math.abs(c.norm.length - nq.length);
      } else if (nq.length >= 4) {
        var windowLen = Math.min(c.norm.length, nq.length + 3);
        var dist = levenshtein(nq, c.norm.slice(0, windowLen));
        var threshold = nq.length <= 5 ? 1 : 2;
        if (dist <= threshold) score = 10 + dist;
      }
      if (score !== null) scored.push({ cat: c, score: score });
    });
    scored.sort(function (a, b) { return a.score - b.score; });
    var seen = {};
    var out = [];
    for (var i = 0; i < scored.length && out.length < MAX_RESULTS; i++) {
      var id = scored[i].cat.id;
      if (seen[id]) continue;
      seen[id] = true;
      out.push(scored[i].cat);
    }
    return out;
  }

  function renderBox(container, matches) {
    if (!container) return;
    if (!matches.length) {
      container.innerHTML = '';
      container.style.display = 'none';
      return;
    }
    var html = '<div class="uncap-diagram-match__inner">' +
      '<span class="uncap-diagram-match__label">Parts diagram' + (matches.length > 1 ? 's' : '') + ' found:</span>' +
      '<ul class="uncap-diagram-match__list">' +
      matches.map(function (m) {
        return '<li><a href="/pages/design?id=' + m.id + '&sort=1&page=1">' + escapeHtml(m.title) + ' → View Diagram</a></li>';
      }).join('') +
      '</ul></div>';
    container.innerHTML = html;
    container.style.display = 'block';
  }

  function renderLoading(container) {
    if (!container) return;
    container.innerHTML = '<span class="uncap-diagram-match--loading">Checking parts diagrams…</span>';
    container.style.display = 'block';
  }

  function ensureContainer(id, referenceSelector, position) {
    var el = document.getElementById(id);
    if (el) return el;
    var ref = document.querySelector(referenceSelector);
    if (!ref || !ref.parentNode) return null;
    el = document.createElement('div');
    el.id = id;
    el.className = 'uncap-diagram-match';
    el.style.display = 'none';
    if (position === 'before') {
      ref.parentNode.insertBefore(el, ref);
    } else {
      ref.parentNode.insertBefore(el, ref.nextSibling);
    }
    return el;
  }

  /* ============================================================
   * PART NUMBER → "what does this fit?" reverse lookup
   * ============================================================ */

  function normPart(str) {
    return (str || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  // Does this query look like a part number rather than a model name?
  function looksLikePartNumber(norm) {
    if (norm.length < PART_MIN_LEN) return false;
    var digits = (norm.match(/[0-9]/g) || []).length;
    return digits >= 5 && (digits / norm.length) >= 0.6;
  }

  // Shopify predictive search does not match "00003503502" against the SKU
  // "0000 350 3502", so rebuild the spaced/grouped forms before querying.
  function buildQueryForms(raw, norm) {
    var forms = [];
    function add(v) {
      v = (v || '').trim();
      if (v && forms.indexOf(v) === -1) forms.push(v);
    }
    if (/^\d{11}$/.test(norm)) add(norm.slice(0, 4) + ' ' + norm.slice(4, 7) + ' ' + norm.slice(7, 11));
    if (/^\d{10}$/.test(norm)) add(norm.slice(0, 4) + ' ' + norm.slice(4, 7) + ' ' + norm.slice(7, 10));
    if (/^\d{9}$/.test(norm)) add(norm.slice(0, 4) + ' ' + norm.slice(4, 6) + ' ' + norm.slice(6, 9));
    add(String(raw || '').trim());
    add(norm);
    return forms.slice(0, 2); // at most two network round-trips
  }

  function suggestProducts(q) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=' + PART_SUGGEST_LIMIT;
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var list = j && j.resources && j.resources.results && j.resources.results.products;
        return list || [];
      })
      .catch(function () { return []; });
  }

  // Products are titled "0000 350 3502 – Pickup body" and handled
  // "stihl-0000-350-3502"; derive the part number from either.
  function productPartKeys(p) {
    var keys = [];
    var title = p.title || '';
    var split = title.split(/\s+[–—-]\s+/);
    if (split.length > 1) {
      var k = normPart(split[0]);
      if (k) keys.push(k);
    }
    var handleNorm = normPart(p.handle || '');
    if (handleNorm) keys.push(handleNorm);
    return keys;
  }

  function partScore(p, norm) {
    var keys = productPartKeys(p);
    var best = 99;
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (!k) continue;
      var d;
      if (k === norm) {
        d = 0;
      } else if (k.length > norm.length && k.slice(k.length - norm.length) === norm) {
        d = 0; // handle carries a brand prefix, e.g. STIHL00003503502
      } else {
        var tail = k.length > norm.length ? k.slice(k.length - norm.length) : k;
        d = Math.min(levenshtein(k, norm), levenshtein(tail, norm));
      }
      if (d < best) best = d;
    }
    return best;
  }

  function partLabel(p) {
    var split = (p.title || '').split(/\s+[–—-]\s+/);
    return split.length > 1 ? split[0].trim() : (p.title || '').trim();
  }

  // "Stihl MS 181 - Motor Housing" -> { model: "Stihl MS 181", section: "Motor Housing" }
  function splitDesignTitle(title) {
    var t = String(title || '').trim();
    var idx = t.indexOf(' - ');
    if (idx === -1) idx = t.indexOf(' – ');
    if (idx === -1) return { model: t, section: '' };
    return { model: t.slice(0, idx).trim(), section: t.slice(idx + 3).trim() };
  }

  function naturalCompare(a, b) {
    return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
  }

  function fetchDesignsForProduct(productId) {
    return fetch(UNCAP_UPSELL_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shop: UNCAP_SHOP, productId: 'gid://shopify/Product/' + productId })
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var d = j && j.data;
        return {
          list: (d && d.designList) || [],
          detailHandle: (d && d.design_detail_handle) || 'design-detail'
        };
      })
      .catch(function () { return { list: [], detailHandle: 'design-detail' }; });
  }

  var partCache = {};

  function resolvePart(raw) {
    var norm = normPart(raw);
    if (!looksLikePartNumber(norm)) return Promise.resolve(null);
    if (partCache[norm]) return partCache[norm];

    partCache[norm] = (async function () {
      var forms = buildQueryForms(raw, norm);
      var seen = {};
      var candidates = [];
      for (var i = 0; i < forms.length; i++) {
        var products = await suggestProducts(forms[i]);
        for (var j = 0; j < products.length; j++) {
          var p = products[j];
          if (!p || seen[p.id]) continue;
          seen[p.id] = true;
          candidates.push({ product: p, score: partScore(p, norm) });
        }
        if (candidates.some(function (c) { return c.score === 0; })) break;
      }
      if (!candidates.length) return { status: 'none', query: raw };

      candidates.sort(function (a, b) { return a.score - b.score; });
      var exact = candidates[0].score === 0 ? candidates[0].product : null;

      if (!exact) {
        var near = candidates
          .filter(function (c) { return c.score <= PART_FUZZY_MAX; })
          .slice(0, PART_DID_YOU_MEAN)
          .map(function (c) { return c.product; });
        return near.length ? { status: 'near', suggestions: near } : { status: 'none', query: raw };
      }

      var res = await fetchDesignsForProduct(exact.id);
      if (!res.list.length) return { status: 'nodiagram', product: exact };

      var byModel = {};
      var order = [];
      var seenDesign = {};
      res.list.forEach(function (d) {
        if (!d || seenDesign[d.id]) return;
        seenDesign[d.id] = true;
        var parts = splitDesignTitle(d.title);
        if (!byModel[parts.model]) { byModel[parts.model] = []; order.push(parts.model); }
        byModel[parts.model].push({
          id: d.id,
          section: parts.section || 'View diagram',
          handle: (d.page_handle && d.page_handle !== '') ? d.page_handle : res.detailHandle
        });
      });
      order.sort(naturalCompare);

      return {
        status: 'ok',
        product: exact,
        totalDesigns: Object.keys(seenDesign).length,
        models: order.map(function (m) { return { model: m, designs: byModel[m] }; })
      };
    })();

    return partCache[norm];
  }

  function renderPartPanel(container, result, onSuggestion) {
    if (!container) return;
    if (!result || result.status === 'none' || result.status === 'nodiagram') {
      container.innerHTML = '';
      container.style.display = 'none';
      return;
    }

    if (result.status === 'near') {
      container.innerHTML = '<span class="uncap-diagram-match__label">No exact part number match — did you mean:</span>' +
        '<ul class="uncap-diagram-match__list">' +
        result.suggestions.map(function (p) {
          return '<li><button type="button" class="uncap-part-match__dym" data-uncap-part="' +
            escapeHtml(partLabel(p)) + '">' + escapeHtml(p.title) + '</button></li>';
        }).join('') + '</ul>';
      container.style.display = 'block';
      Array.prototype.forEach.call(container.querySelectorAll('[data-uncap-part]'), function (btn) {
        btn.addEventListener('click', function () {
          onSuggestion(btn.getAttribute('data-uncap-part'));
        });
      });
      return;
    }

    var modelCount = result.models.length;
    var visible = result.models.slice(0, PART_MODELS_VISIBLE);
    var hidden = result.models.slice(PART_MODELS_VISIBLE);

    function modelHtml(m) {
      return '<li><span class="uncap-part-match__model">' + escapeHtml(m.model) + '</span>' +
        '<span class="uncap-part-match__links">' +
        m.designs.map(function (d) {
          return '<a href="/pages/' + encodeURIComponent(d.handle) + '?id=' + encodeURIComponent(d.id) + '">' +
            escapeHtml(d.section) + '</a>';
        }).join('<span class="uncap-part-match__sep">·</span>') +
        '</span></li>';
    }

    var html = '<span class="uncap-diagram-match__label">' +
      '<a href="/products/' + encodeURIComponent(result.product.handle) + '">' +
      escapeHtml(result.product.title) + '</a></span>' +
      '<span class="uncap-part-match__meta">Fits ' + modelCount + ' machine' + (modelCount === 1 ? '' : 's') +
      ' — found on ' + result.totalDesigns + ' parts diagram' + (result.totalDesigns === 1 ? '' : 's') +
      '. Click a diagram to see it in place.</span>' +
      '<ul class="uncap-part-match__models">' + visible.map(modelHtml).join('') + '</ul>';

    if (hidden.length) {
      html += '<ul class="uncap-part-match__models" data-uncap-hidden style="display:none">' +
        hidden.map(modelHtml).join('') + '</ul>' +
        '<button type="button" class="uncap-part-match__more">Show all ' + modelCount + ' machines</button>';
    }

    container.innerHTML = html;
    container.style.display = 'block';

    var moreBtn = container.querySelector('.uncap-part-match__more');
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var list = container.querySelector('[data-uncap-hidden]');
        if (!list) return;
        var open = list.style.display !== 'none';
        list.style.display = open ? 'none' : 'block';
        moreBtn.textContent = open ? ('Show all ' + modelCount + ' machines') : 'Show fewer';
      });
    }
  }

  var queryCounter = 0;
  function handleQuery(query, container, partContainer, onSuggestion) {
    if (!container && !partContainer) return;
    var myToken = ++queryCounter;
    if (!categoriesPromise || !getCache()) {
      renderLoading(container);
    }
    loadCategories().then(function (cats) {
      if (myToken !== queryCounter) return; // a newer query superseded this one
      var matches = findMatches(query, cats);
      renderBox(container, matches);
    });
    if (partContainer) {
      resolvePart(query).then(function (result) {
        if (myToken !== queryCounter) return;
        renderPartPanel(partContainer, result, onSuggestion || function () {});
      });
    }
  }

  function clearBoxes() {
    ['uncap-diagram-match-drawer', 'uncap-diagram-match-page',
     'uncap-part-match-drawer', 'uncap-part-match-page'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) { el.innerHTML = ''; el.style.display = 'none'; }
    });
  }

  function initDrawer() {
    var input = document.querySelector('[data-searchbar__input]');
    if (!input) return;
    var timer;

    function run(val) {
      var container = ensureContainer('uncap-diagram-match-drawer', '[data-search-result]', 'before');
      var partContainer = ensureContainer('uncap-part-match-drawer', '[data-search-result]', 'before');
      if (String(val).replace(/\s/g, '').length === 0) {
        queryCounter++;
        clearBoxes();
        return;
      }
      handleQuery(val, container, partContainer, function (partNo) {
        input.value = partNo;
        run(partNo);
      });
    }

    input.addEventListener('keyup', function () {
      clearTimeout(timer);
      var val = input.value;
      timer = setTimeout(function () { run(val); }, 250);
    });
  }

  function initSearchPage() {
    var params = new URLSearchParams(window.location.search);
    var q = params.get('q');
    if (!q) return;
    var container = ensureContainer('uncap-diagram-match-page', '.search__content-box', 'before');
    var partContainer = ensureContainer('uncap-part-match-page', '.search__content-box', 'before');
    handleQuery(q, container, partContainer, function (partNo) {
      window.location.href = '/search?q=' + encodeURIComponent(partNo);
    });
  }

  function init() {
    injectStyle();
    loadCategories(); // warm the cache as early as possible
    initDrawer();
    initSearchPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
